import isEmpty from "is-empty";

export default {

    isEmptyNotZero: (value) => {
        return (value === null || value === undefined);
    },

    isEmpty: (value) => {
        return isEmpty(value);
    },

    getDistanceFromLatLng: (lat1, lng1, lat2, lng2, miles) => {
        if (typeof miles === "undefined") {
            miles = false;
        }

        if (lat1 === "" || lng1 === "" || lat2 === "" || lng2 === "") {
            return "-";
        }

        const deg2rad = (deg) => {
            return deg * (Math.PI/180);
        };
        const square = (x)=> {
            return Math.pow(x, 2);
        };

        const r= 6371; // radius of the earth in km
        lat1 = deg2rad(lat1);
        lat2 = deg2rad(lat2);
        const lat_dif=lat2-lat1;
        const lng_dif = deg2rad(lng2-lng1);
        const a= square(Math.sin(lat_dif / 2)) + Math.cos(lat1) * Math.cos(lat2) * square(Math.sin(lng_dif / 2));
        const d= 2 * r * Math.asin(Math.sqrt(a));
        let distance = 0;
        if (miles) {
            distance = d * 0.621371;
        } //return miles
        else {
            distance = d;
        } //return km

        return Math.floor(distance);
    }
}
